import { render } from "./Vouchers.vue?vue&type=template&id=48894c7c&scoped=true"
import script from "./Vouchers.vue?vue&type=script&lang=js"
export * from "./Vouchers.vue?vue&type=script&lang=js"

import "./Vouchers.vue?vue&type=style&index=0&id=48894c7c&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48894c7c"]])

export default __exports__